import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import AppLoader from './components/Loaders/AppLoader.jsx';
// import { messaging } from '../public/firebaseConfigICACall.js'; // Ensure correct import path
// import { onMessage, getMessaging } from 'firebase/messaging';
import toast from 'react-hot-toast';
import logoImage from '../public/assets/Convrt_bg_remover.png'

// Register Firebase Service Worker for Push Notifications
// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker
//         .register('/Guest-Call-messaging-sw.js')
//         .then((registration) => {
//             console.log('Service Worker registered successfully:', registration);
//         })
//         .catch((error) => {
//             console.error('Service Worker registration failed:', error);
//         });
// }

// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//         navigator.serviceWorker
//             .register('/iconnctAdminPanel/Guest-Call-messaging-sw.js', { scope: '/iconnctAdminPanel/' })
//             .then((registration) => {
//                 console.log('Service Worker registered with scope:', registration.scope);

//                 // Initialize Firebase Messaging
//                 const messaging = getMessaging();

//                 // Set the Service Worker manually for messaging if needed
//                 messaging.onMessage((payload) => {
//                     console.log('Message received:', payload);
//                 });
//             })
//             .catch((error) => {
//                 console.error('Service Worker registration failed:', error);
//             });
//     });
// }



// Handle foreground notifications
// onMessage(messaging, (payload) => {-
//     console.log('Foreground message received1213:', payload);
//     if (payload.notification) {
//         const { title, body } = payload.notification;
//         // Display Toast Notification
//         toast.custom((t) => (
//             <div
//                 className={`custom-toast ${t.visible ? 'show' : 'hide'}`}
//             >
//                 <button onClick={() => toast.dismiss(t.id)} className="toast-close-button">
//                     ✕
//                 </button>
//                 <div className="toast-content">

//                     <div className="toast-avatar">
//                         <img
//                             src={logoImage}
//                             alt="User Avatar"
//                         />
//                     </div>
//                     <div className="toast-body">
//                         <p className="toast-title">{title}</p>
//                         <p className="toast-message">{body}</p>
//                     </div>
//                 </div>
//                 <hr className="toast-divider" />

//             </div>
//         ),
//             {
//                 duration: 2000, 
//             }
//         );
//     }
//     const { title, body } = payload.notification;
//     new Notification(title, { body });
// });
ReactDOM.createRoot(document.getElementById('root')).render(
    <Suspense fallback={<AppLoader />}>
        <App />
    </Suspense>
);
